export default "__VITE_ASSET__CDB_4Iga__"